import * as React from 'react';

const SvgReddit = (props) => (
  <svg
    width={40}
    height={40}
    xmlns="http://www.w3.org/2000/svg"
    className="fill-current text-black dark:text-white"
    {...props}
  >
    <path d="M15.703 23.906c1.094 0 1.953-.86 1.953-1.953 0-1.015-.86-1.953-1.953-1.953-1.094 0-1.953.938-1.953 1.953 0 1.094.86 1.953 1.953 1.953ZM39.375 20C39.375 9.297 30.703.625 20 .625S.625 9.297.625 20 9.297 39.375 20 39.375 39.375 30.703 39.375 20Zm-10.39-3.203c2.734 0 3.593 3.672 1.171 4.922.078.39.157.781.157 1.25 0 4.062-4.61 7.422-10.313 7.422S9.687 27.03 9.687 22.969c0-.469 0-.86.079-1.25-2.422-1.25-1.563-4.922 1.171-4.922.704 0 1.407.312 1.876.781 1.718-1.172 4.062-1.953 6.64-2.031l1.563-6.797c0-.234.234-.39.468-.313l4.844 1.016c.313-.625.938-1.015 1.719-1.015 1.094 0 1.953.859 1.953 1.953 0 1.015-.86 1.875-1.953 1.875-1.094 0-1.953-.86-1.953-1.875l-4.297-1.016-1.406 6.172c2.656.078 5 .86 6.718 2.031.547-.469 1.172-.781 1.875-.781Zm-5.391 9.062c-1.407 1.485-5.938 1.407-7.266 0-.156-.156-.469-.156-.703 0-.156.235-.156.547 0 .703 1.797 1.797 6.875 1.797 8.672 0 .156-.156.156-.468 0-.703a.586.586 0 0 0-.703 0ZM24.219 20c-1.094 0-1.953.938-1.953 1.953 0 1.094.937 1.953 1.953 1.953 1.093 0 1.953-.86 1.953-1.953 0-1.015-.86-1.953-1.953-1.953Z" />
  </svg>
);

export default SvgReddit;
